<template>
  <div class="bb-sidebar-company"
       v-if="companiesList.length && userInfo.role === founder"
       @mouseleave="companyListOpen = false">
    <div class="bb-sidebar-active-company"
         :class="{'bb-sidebar-active-company_open-list':companyListOpen && sidebarOpen}"
         @click="openListCompany()">
      <div class="bb-sidebar-active-company__avatar">
        <img :src="selectCompany.image ? selectCompany.image.path : defaultAvatar"/>
      </div>
      <transition name="fade">
        <div v-if="sidebarOpen" class="bb-sidebar-active-company__wrapper">
          <span class="bb-sidebar-active-company__name">{{selectCompany.name}}</span>
          <i class="icon-arrow bb-sidebar-active-company__arrow"
             :class="{'bb-sidebar-active-company__arrow_active':companyListOpen}"></i>
        </div>
      </transition>
    </div>
    <transition name="slide-company">
      <div v-if="companyListOpen && sidebarOpen" class="bb-sidebar-company-list">
        <div v-for="(company, index) in companiesList" :key="company.id" >
        <div class="bb-sidebar-company-list-item"
             @click="setActiveCompany(index, company)"
        >
          <img class="bb-sidebar-company-list-item__avatar" :src="company.image ? company.image.path : defaultAvatar"/>
          <span class="bb-sidebar-company-list-item__name">{{company.name}}</span>
        </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {FOUNDER} from '@/constants/roles'
import defaultAvatar from '@/assets/images/avatar-company-default.png'

export default {
  name: 'CompanyList',
  props: {sidebarOpen: Boolean},
  data () {
    return {
      defaultAvatar: defaultAvatar,
      founder: FOUNDER.id,
      companyListOpen: false,
      loaderRun: false
    }
  },
  computed: {
    companiesList: {
      get: function () {
        return this.$store.getters.companiesList
      },
      set: function (data) {
        this.$store.dispatch('setCompaniesList', data)
      }
    },
    activeCompany: {
      get: function () {
        return this.$store.getters.activeCompany
      },
      set: function (data) {
        this.$store.dispatch('setActiveCompany', data)
      }
    },
    positionsList: {
      get: function () {
        return this.$store.getters.positionsList
      },
      set: function (data) {
        this.$store.dispatch('setPositionsList', data)
      }
    },
    userInfo: function () {
      return this.$store.getters.userInfo
    },
    selectCompany: function () {
      const active = this.companiesList.find((item) => item.id === this.activeCompany)
      return active || this.companiesList[0]
    }
  },
  methods: {
    openListCompany: function () {
      this.companyListOpen = !this.companyListOpen
    },
    setActiveCompany (index, company) {
      const { id } = company
      this.activeCompany = id
      this.$store.dispatch('setCurrentCompany', company)
      this.companiesList.splice(index, 1, company)
      this.$cookie.set('company', id)
      this.$store.dispatch('setPositionsList', [])
      this.$store.dispatch('setUsersList', [])
      this.companyListOpen = false
      this.$router.push({name: 'Dashboard'}).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/transition";

  .bb-sidebar {

    &-active-company,
    &-company-list-item {
      cursor: pointer;

      &__name {
        white-space: nowrap;
        margin-left: 17px;
      }

      &__avatar {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 34px;
        min-width: 34px;
        height: 34px;
        object-fit: contain;
        border-radius: 50%;
        box-sizing: border-box;
        margin: 7px 0;

        img {
          border-radius: 50%;
          max-width: 100%;
        }
      }
    }

    &-company {
      position: relative;
      min-width: 81px;
      padding: 25px 16px 0;
      color: $color-white;

      &-list {

        &-item {
          display: flex;
          align-items: center;

          &:hover img {
            border: 2px solid $color-white;
            transition: all .2s;
          }

          &__name {
            font-size: 13px;
            line-height: 16px;
          }

          &__avatar {
            border: 2px solid transparent;
          }
        }
      }
    }

    &-active-company {
      display: flex;
      align-items: center;
      height: 49px;
      min-width: 100%;
      padding: 7px;
      border-radius: 7px;
      background-color: $color-accent-hover;
      z-index: 2;

      &__avatar {
        border: 2px solid $color-white;
      }

      &__name {
        font-size: 14px;
        line-height: 17px;
        opacity: 1;
      }

      &__wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      }

      &__arrow {
        transform: rotate(180deg);
        margin-right: 10px;
        transition: .15s;
      }

      &__arrow_active {
        transform: rotate(0deg);
      }

      &_open-list {
        border-radius: 0 0 7px 7px;
        transition: all .2s;
      }
    }

    &-company-list {
      position: absolute;
      display: flex;
      flex-direction: column;
      bottom: 50px;
      background-color: $color-accent-hover;
      border-radius: 7px 7px 0 0;
      padding: 7px 7px 0;
      margin-bottom: -2px;
      width: 247px;
      z-index: 3;
      box-shadow: 0 -6px 8px rgba($color-black, 0.04);

      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 10px;
        right: 10px;
        height: 1px;
        opacity: 0.22;
        background-color: $color-white;
        margin: auto;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/CompanyList/CompanyList.vue